(function () {
  function getRoot() {
    return document.querySelector('[data-mb-cartd-root]');
  }

  function getPdpNudgeRoot() {
    return document.querySelector('[data-mb-pdp-nudge-root]');
  }

  function open() {
    var root = getRoot();
    if (!root) return;
    root.classList.add('is-open');
    document.body.classList.add('mb-cartd-lock');
    var panel = root.querySelector('.mb-cartd__panel');
    if (panel) panel.focus();
  }

  function close() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('mb-cartd-lock');
  }

  function updateHeaderCartCount(count) {
    document.querySelectorAll('[data-mb-hdr-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // Both the cart drawer's own shipping bar (snippets/mecca-cart-drawer.liquid)
  // and the PDP's shipping nudge (sections/mecca-pdp-main.liquid) render a
  // USD-based free-shipping threshold server-side (correct for USD visitors,
  // a safe no-JS fallback otherwise) and carry data-threshold-cents/
  // data-unlocked-text/data-remaining-text so this can correct them for any
  // visitor Shopify Markets is showing a different currency to. Shopify
  // injects window.Shopify.currency = {active, rate} on every storefront
  // page specifically for this kind of client-side conversion. cart.total_price
  // from /cart.js is already expressed in that same active/presentment
  // currency, so once we scale the USD threshold by the same rate the two
  // are directly comparable.
  function correctShippingBars(cart) {
    if (!(window.Shopify && window.Shopify.currency)) return;
    var active = window.Shopify.currency.active;
    var rate = parseFloat(window.Shopify.currency.rate);
    if (!active || !rate || rate === 1) return; // visitor is already in the shop's base currency; SSR values are correct.

    var bars = document.querySelectorAll('[data-mb-shipbar]');
    if (!bars.length) return;

    function apply(cartData) {
      var formatter;
      try {
        formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: active });
      } catch (e) {
        formatter = null;
      }

      bars.forEach(function (bar) {
        var baseThresholdCents = parseFloat(bar.getAttribute('data-threshold-cents'));
        if (!baseThresholdCents) return;
        var thresholdCents = baseThresholdCents * rate;
        var totalCents = cartData.total_price;
        var textEl = bar.querySelector('[data-mb-shipbar-text]');
        var fillEl = bar.querySelector('[data-mb-shipbar-fill]');
        if (!textEl || !fillEl) return;

        if (totalCents >= thresholdCents) {
          textEl.innerHTML = '<b>' + escapeHtml(bar.getAttribute('data-unlocked-text') || '') + '</b>';
          fillEl.style.width = '100%';
        } else {
          var remainingAmount = (thresholdCents - totalCents) / 100;
          var remainingFormatted = formatter ? formatter.format(remainingAmount) : (active + ' ' + remainingAmount.toFixed(2));
          var pct = (totalCents / thresholdCents) * 100;
          if (pct < 0) pct = 0;
          if (pct > 100) pct = 100;
          var template = bar.getAttribute('data-remaining-text') || '';
          textEl.innerHTML = escapeHtml(template).replace('[[remaining]]', '<b>' + escapeHtml(remainingFormatted) + '</b>');
          fillEl.style.width = pct + '%';
        }
      });
    }

    if (cart) {
      apply(cart);
    } else {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(apply)
        .catch(function (err) {
          console.error('Mecca shipping bar currency correction failed', err);
        });
    }
  }

  // Also refreshed by refreshDrawer() below (same fetch, same trigger:
  // any /cart/add submit or quantity change) so the PDP's own "free
  // shipping" progress nudge (sections/mecca-pdp-main.liquid) stays in
  // sync with the cart drawer's shipping bar without a page reload —
  // both read the same threshold (snippets/mecca-free-shipping-threshold.liquid).
  function refreshPdpNudge(sectionsData) {
    var pdpNudge = getPdpNudgeRoot();
    if (!pdpNudge) return;
    var pdpSectionId = pdpNudge.getAttribute('data-section-id');
    var html = sectionsData[pdpSectionId];
    if (!html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newNudge = doc.querySelector('[data-mb-pdp-nudge-root]');
    if (newNudge && pdpNudge.parentNode) {
      pdpNudge.parentNode.replaceChild(newNudge, pdpNudge);
    }
  }

  function refreshDrawer(thenOpen) {
    var root = getRoot();
    if (!root) return Promise.resolve();
    var sectionId = root.getAttribute('data-section-id');

    var pdpNudge = getPdpNudgeRoot();
    var sectionIds = [sectionId];
    if (pdpNudge) {
      var pdpSectionId = pdpNudge.getAttribute('data-section-id');
      if (pdpSectionId) sectionIds.push(pdpSectionId);
    }

    return fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('[data-mb-cartd-root]');
          if (newRoot && root.parentNode) {
            // Preserve open/closed state across the swap.
            if (root.classList.contains('is-open')) newRoot.classList.add('is-open');
            root.parentNode.replaceChild(newRoot, root);
          }
        }

        refreshPdpNudge(data);

        loadCrossSell();
        if (thenOpen) open();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateHeaderCartCount(cart.item_count);
        correctShippingBars(cart);
      })
      .catch(function (err) {
        console.error('Mecca cart drawer: failed to refresh', err);
      });
  }

  function changeLineQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) { return res.json(); });
  }

  function fetchRecommendationsFor(baseUrl, productId) {
    var url = baseUrl + '?section_id=mecca-cart-recommendations&product_id=' + productId + '&limit=4';
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var script = doc.querySelector('[data-mb-cart-rec-data]');
        if (!script) return [];
        try {
          return JSON.parse(script.textContent) || [];
        } catch (e) {
          return [];
        }
      })
      .catch(function () { return []; });
  }

  function renderCrossSellItem(product) {
    var img = product.image
      ? '<img src="' + product.image + '" alt="" loading="lazy" width="40" height="40">'
      : '';
    return (
      '<a class="mb-cartd__cross-cov" href="' + product.url + '">' + img + '</a>' +
      '<div class="mb-cartd__cross-info">' +
        '<div class="mb-cartd__cross-t"><a href="' + product.url + '">' + product.title + '</a></div>' +
        '<div class="mb-cartd__cross-s">' + product.price + '</div>' +
      '</div>' +
      '<button type="button" class="mb-cartd__cross-add" data-mb-cartd-quick-add data-variant-id="' + product.variantId + '">Add</button>'
    );
  }

  function loadCrossSell() {
    var container = document.querySelector('[data-mb-cartd-cross]');
    var idsScript = document.querySelector('[data-mb-cartd-product-ids]');
    if (!container || !idsScript) return;

    var recommendationsUrl = container.getAttribute('data-recommendations-url');
    var slot = container.querySelector('[data-mb-cartd-cross-item]');
    if (!recommendationsUrl || !slot) return;

    var cartProductIds;
    try {
      cartProductIds = JSON.parse(idsScript.textContent) || [];
    } catch (e) {
      cartProductIds = [];
    }
    if (!cartProductIds.length) return;

    Promise.all(cartProductIds.map(function (id) { return fetchRecommendationsFor(recommendationsUrl, id); }))
      .then(function (results) {
        var seen = {};
        var merged = [];
        results.forEach(function (list) {
          list.forEach(function (product) {
            if (cartProductIds.indexOf(product.id) !== -1) return;
            if (seen[product.id]) return;
            seen[product.id] = true;
            merged.push(product);
          });
        });
        if (!merged.length) return;

        slot.innerHTML = renderCrossSellItem(merged[0]);
        container.hidden = false;
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mb-hdr-open-cart]')) {
      e.preventDefault();
      refreshDrawer(true);
      return;
    }
    if (e.target.closest('[data-mb-cartd-close]') || e.target.closest('[data-mb-cartd-overlay]')) {
      close();
      return;
    }

    var decreaseBtn = e.target.closest('[data-mb-cartd-qty-decrease]');
    var increaseBtn = e.target.closest('[data-mb-cartd-qty-increase]');
    var removeBtn = e.target.closest('[data-mb-cartd-remove]');
    var quickAddBtn = e.target.closest('[data-mb-cartd-quick-add]');

    if (decreaseBtn || increaseBtn) {
      var line = (decreaseBtn || increaseBtn).closest('[data-mb-cartd-line]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var valueEl = line.querySelector('.mb-cartd__qty-n');
      var current = parseInt(valueEl.textContent, 10) || 1;
      var next = increaseBtn ? current + 1 : Math.max(0, current - 1);
      line.style.opacity = '0.5';
      changeLineQuantity(key, next).then(function () { refreshDrawer(false); });
      return;
    }

    if (removeBtn) {
      var removeLine = removeBtn.closest('[data-mb-cartd-line]');
      if (!removeLine) return;
      removeLine.style.opacity = '0.5';
      changeLineQuantity(removeLine.getAttribute('data-line-key'), 0).then(function () { refreshDrawer(false); });
      return;
    }

    if (quickAddBtn) {
      var variantId = quickAddBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      quickAddBtn.disabled = true;
      quickAddBtn.textContent = '...';
      addItems([{ id: variantId, quantity: 1 }])
        .then(function () { refreshDrawer(false); })
        .catch(function () {
          quickAddBtn.disabled = false;
          quickAddBtn.textContent = 'Add';
        });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Intercept any product-add-to-cart form on the site (e.g. the PDP's
  // {% form 'product' %}) so it adds via ajax and opens this drawer,
  // instead of doing a full page submit/redirect. While the request is in
  // flight the button shows the canonical "loading" button state (spinner
  // + "Adding…" label, matching upgrade/component-sheet.html section 01) —
  // its own label/markup is restored afterwards either way.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    var originalHTML = null;
    if (submitBtn) {
      originalHTML = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.classList.add('mb-btn-is-loading');
      submitBtn.innerHTML = '<span class="mb-btn-spin"></span> Adding…';
    }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function () { return refreshDrawer(true); })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('mb-btn-is-loading');
          submitBtn.innerHTML = originalHTML;
        }
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    loadCrossSell();
    correctShippingBars();
  });
})();